import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../environments/environment';
import { MessageResourceTypeMappings } from '@aa/nest/resource';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class ChatService {
  socket: Socket;

  newMessage$ = new Subject<
    MessageResourceTypeMappings['resourceWithRelationsT']
  >();
  messageUpdated$ = new Subject<
    MessageResourceTypeMappings['resourceWithRelationsT']
  >();

  reset$ = new Subject<void>();
  connected$ = new BehaviorSubject(false);

  constructor(
    protected readonly http: HttpClient,
    private readonly authService: AuthService,
  ) {
    this.socket = io(environment.chatService, {
      withCredentials: true,
    });
    this.setupSocket();

    setInterval(
      async () => {
        await firstValueFrom(this.authService.refresh());
        this.setupSocket(true);
      },
      4 * 60 * 1000,
    );
  }

  setupSocket(disconnect = false) {
    if (disconnect) {
      if (this.socket?.connected) {
        this.socket.disconnect();
      }
    }
    if (this.socket.disconnected) {
      this.socket.connect();
    }
    this.socket.onAny((...args) => {
      // console.log('EVENT!', args);
    });
    this.socket.off('new-message');
    this.socket.off('message-updated');
    this.socket.off('connect');
    this.socket.on('new-message', (message) => {
      console.log('NEW MESSAGE', message);
      this.newMessage$.next(JSON.parse(message ?? ''));
    });
    this.socket.on('message-updated', (message) => {
      this.messageUpdated$.next(JSON.parse(message ?? ''));
    });

    this.socket.on('connect', () => {
      console.log('CONNECTED!');
      this.setupSocket();
    });
    this.socket.on('disconnect', () => {
      console.log('DISCONNECTED!');
    });
    // console.log('RE-SETUP');
    this.reset$.next();
  }

  connectToChannel(channelId: number) {
    if (this.socket.disconnected) this.socket.connect();
    this.socket.emit('connect-to-thread', channelId);
  }

  disconnectFromChannel(channelId: number) {
    if (this.socket.disconnected) this.socket.connect();
    this.socket.emit('disconnect-from-thread', channelId);
  }

  async sendMessage(data: MessageResourceTypeMappings['createDTO']) {
    if (this.socket.disconnected) this.socket.connect();
    this.socket.emit('send-message', data);
  }

  updateMessage(
    messageId: number,
    updates: MessageResourceTypeMappings['updateDTO'],
  ) {
    if (this.socket.disconnected) this.socket.connect();
    this.socket.emit('update-message', messageId, updates);
  }
}
